<template>
  <div id="pageServers">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>

        <!-- Page header -->
        <v-flex xs12>
          <div class="modern-page-header">
            <div class="modern-page-header__left">
              <div class="modern-page-header__icon-wrap">
                <v-icon class="modern-page-header__icon">dns</v-icon>
              </div>
              <div>
                <h3 class="modern-page-header__title">Server Monitor</h3>
                <p class="modern-page-header__sub">Live status of all PM2 application processes</p>
              </div>
            </div>
            <div class="modern-page-header__actions">
              <v-btn flat color="secondary" class="modern-action-btn" @click="handleGet">
                <v-icon left small>refresh</v-icon>Refresh
              </v-btn>
              <v-btn flat color="info" class="modern-action-btn" @click="backupServerDatabases">
                <v-icon left small>backup</v-icon>Backup
              </v-btn>
              <v-btn depressed color="primary" class="modern-action-btn modern-action-btn--primary" @click="setupNewServer">
                <v-icon left small>add</v-icon>Setup Server
              </v-btn>
            </div>
          </div>
        </v-flex>

        <!-- Server table -->
        <v-flex lg12>
          <v-card class="modern-table-card">
            <div class="modern-table-toolbar">
              <div class="modern-search-wrap">
                <v-icon class="modern-search-icon">search</v-icon>
                <input
                  v-model="search"
                  class="modern-search-input"
                  placeholder="Search servers..."
                />
              </div>
            </div>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="complex.items"
                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                item-key="name"
                class="modern-data-table"
              >
                <template slot="items" slot-scope="props">
                  <td class="table-cell-mono">{{ props.item.pid }}</td>
                  <td class="table-cell-primary">{{ props.item.name }}</td>
                  <td>
                    <div class="status-badge" :class="props.item.pm2_env.status === 'online' ? 'status-badge--online' : 'status-badge--offline'">
                      <span class="status-badge__dot"></span>
                      {{ props.item.pm2_env.status }}
                    </div>
                  </td>
                  <td class="table-cell-secondary">
                    <span class="metric-value">{{ props.item.monit.cpu }}</span>
                    <span class="metric-unit">%</span>
                  </td>
                  <td class="table-cell-secondary">
                    <span class="metric-value">{{ parseInt(parseFloat(props.item.monit.memory) / 1024 / 1024) }}</span>
                    <span class="metric-unit">MB</span>
                  </td>
                  <td class="table-cell-secondary">
                    {{ new Date(props.item.pm2_env.created_at).toLocaleString() }}
                  </td>
                  <td class="table-cell-secondary">
                    <v-chip small class="restart-chip">{{ props.item.pm2_env.restart_time }}</v-chip>
                  </td>
                </template>
                <template slot="no-data">
                  <div class="modern-empty-state">
                    <v-icon class="modern-empty-state__icon">dns</v-icon>
                    <p class="modern-empty-state__text">No servers found</p>
                    <v-btn color="primary" depressed small @click="handleGet">Refresh</v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <BackupDB ref="backupDB" @addModule=""></BackupDB>
    </v-container>
  </div>
</template>

<script>
import API from "@/mixins/APIServer";
import BackupDB from "./BackupDB.vue";
export default {
  mixins: [API],
  components: { BackupDB },
  data() {
    return {
      search: "",
      complex: {
        selected: [],
        headers: [
          { text: "PID", value: "pid" },
          { text: "Name", value: "name" },
          { text: "Status", value: "pm2_env.status" },
          { text: "CPU", value: "cpu" },
          { text: "Memory", value: "memory" },
          { text: "Created On", value: "pm2_env.created_at" },
          { text: "Restarts", value: "" }
        ],
        items: []
      }
    };
  },
  created() {
    this.handleGet();
    for (var item of this.complex.items) {
      item.sortable = false;
    }
  },
  methods: {
    handleGet: async function() {
      try {
        let res = await this.listServers();
        this.complex.items = res.data;
      } catch (error) {
        this.$toast.error("Failed to fetch details.", "Error", { position: "topCenter" });
      }
    },
    backupServerDatabases: async function() {
      this.$refs.backupDB.showDialog();
    },
    setupNewServer: function() {
      this.$router.push({ name: "SetupServer" });
    }
  }
};
</script>

<style scoped lang="css">
.modern-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.modern-page-header__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-page-header__icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #37474F, #263238);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modern-page-header__icon {
  color: #ffffff !important;
  font-size: 22px !important;
}

.modern-page-header__title {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.3px;
}

.modern-page-header__sub {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 13px;
  color: #64748b;
  margin: 2px 0 0;
}

.modern-page-header__actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.modern-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 500 !important;
  text-transform: none !important;
  border-radius: 10px !important;
  height: 38px !important;
  letter-spacing: 0.2px !important;
}

.modern-action-btn--primary {
  box-shadow: 0 2px 8px rgba(21, 101, 192, 0.3) !important;
}

.modern-table-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.modern-table-toolbar {
  display: flex;
  align-items: center;
  padding: 14px 16px;
}

.modern-search-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  gap: 10px;
  transition: border-color 0.2s ease;
  max-width: 360px;
}

.modern-search-wrap:focus-within {
  border-color: #1565C0;
  background: #ffffff;
}

.modern-search-icon {
  color: #94a3b8 !important;
  font-size: 18px !important;
}

.modern-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 14px;
  color: #334155;
  width: 100%;
}

.modern-search-input::placeholder {
  color: #94a3b8;
}

.table-cell-mono {
  font-family: 'SF Mono', 'Roboto Mono', monospace;
  font-size: 13px !important;
  color: #475569 !important;
}

.table-cell-primary {
  font-weight: 600 !important;
  color: #1e293b !important;
}

.table-cell-secondary {
  color: #64748b !important;
  font-size: 14px !important;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}

.status-badge--online {
  background: rgba(67, 160, 71, 0.1);
  color: #2e7d32;
}

.status-badge--offline {
  background: rgba(244, 67, 54, 0.1);
  color: #c62828;
}

.status-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-badge--online .status-badge__dot {
  background: #43a047;
  box-shadow: 0 0 0 2px rgba(67, 160, 71, 0.25);
}

.status-badge--offline .status-badge__dot {
  background: #e53935;
}

.metric-value {
  font-weight: 600;
  color: #334155;
}

.metric-unit {
  font-size: 11px;
  color: #94a3b8;
  margin-left: 1px;
}

.restart-chip {
  background: #f1f5f9 !important;
  color: #475569 !important;
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  height: 22px !important;
}

.modern-empty-state {
  padding: 60px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.modern-empty-state__icon {
  font-size: 48px !important;
  color: #cbd5e1 !important;
}

.modern-empty-state__text {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 15px;
  color: #94a3b8;
  margin: 0;
}
</style>
